'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _lodash = require('lodash');

var _ConfigStore = require('./ConfigStore');

var _ConfigStore2 = _interopRequireDefault(_ConfigStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = {};

var APIUrl = 'https://api.mybuildercloud.com/api/v1';
var BackupAPIUrl = 'https://api2.mybuildercloud.com/api/v1';

var onServer = process.env.REACT_APP_SERVER;

/**
 * Builder Cloud API Request
 */

var BuilderCloud = function () {
  (0, _createClass3.default)(BuilderCloud, null, [{
    key: 'clearCache',
    value: function clearCache() {
      cache = {};
    }

    /**
     * @param  {String} resource   API Resource
     * @param  {Object} parameters
     *   Query string parameters as key=>value object {where: {}, projection: {}, emdedded: {}}
     * @public
     */

  }]);

  function BuilderCloud(resource, parameters) {
    (0, _classCallCheck3.default)(this, BuilderCloud);

    /** @private */
    this.resource = resource;
    /** @private */
    this.parameters = parameters || {};
    this.initWhere();
  }

  /**
   * Initialize the where clause, builder_id is a requirement for the API
   *
   * @protected
   */


  (0, _createClass3.default)(BuilderCloud, [{
    key: 'initWhere',
    value: function initWhere() {
      if ((0, _typeof3.default)(this.parameters.where) !== 'object') {
        this.parameters.where = {};
      }
    }

    /**
     * Get the data from the API server
     *
     * @public
     *
     * @return {object}
     */

  }, {
    key: 'getResource',
    value: function getResource(retry) {
      var _this = this;

      var url = (retry ? _ConfigStore2.default.getConfig('apis.buildercloud_backup', BackupAPIUrl) : _ConfigStore2.default.getConfig('apis.buildercloud', APIUrl)) + '/' + this.resource;
      var cacheKey = '' + url + (0, _stringify2.default)(this.parameters);

      if (cache[cacheKey] !== undefined) {
        return cache[cacheKey];
      }

      cache[cacheKey] = _axios2.default.get(url, {
        params: (0, _extends3.default)({}, this.parameters)
      }).then(function (res) {
        return res;
      }).catch(function (e) {
        if (!retry) {
          if (onServer) {
            console.log('Retrying request ' + decodeURI((0, _lodash.get)(e, 'response.request.responseURL', url)));
          }
          return _this.getResource(true);
        }

        if (onServer) {
          console.error('Failed request ' + decodeURI((0, _lodash.get)(e, 'response.request.responseURL', url)));
        }
        return _promise2.default.reject(e);
      });

      return cache[cacheKey];
    }
  }]);
  return BuilderCloud;
}();

exports.default = BuilderCloud;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/BuilderCloud.js
// module id = 984
// module chunks = 0